import CryptoJS from "crypto-js";
import { storageLocal } from "../view/util/storage";
import { getShortVidCallback } from "./trigger";

// 信息流/SDK v3版本下 渠道号及其他信息的加密处理
const asecAgentData = async (kid, type, device) => {
  console.log("分包渠道号处理----", kid);

  let tgmag = localStorage.getItem("agent") || "x7z1";

  let tgmudid = tgmag;

  let key = "9917987690129917";

  if (storageLocal.has("tgm_uuid") || kid) {
    if (storageLocal.has("tgm_uuid")) {
      // type == 1 安卓/企业签游戏下载 用原vid；否则 就是超级签下载 换短vid
      let shortVid = type == 1 ? storageLocal.get("tgm_uuid") : await getShortVidCallback();

      // device == 2 安卓v1分包
      if (device == 2) {
        key = '1234567890123456';
        tgmudid = tgmudid + '~' + shortVid + '~vid';
      } else {
        let obj = {
          agent: tgmudid,
          vid: shortVid,
        };

        tgmudid = JSON.stringify(obj);
      }
    } else if (kid) {
      if (device == 2) {
        key = '1234567890123456';
        tgmudid = tgmudid + '~' + kid + '~kid';
      } else {
        let obj = {
          agent: tgmudid,
          kid,
        };

        tgmudid = JSON.stringify(obj);
      }
    }

    console.log("tgmudid----", tgmudid);

    // 密钥和明文
    let plaintext = tgmudid;

    // 确保密钥长度为16字节
    key = CryptoJS.enc.Utf8.parse(key);

    // 加密数据
    let encrypted = CryptoJS.AES.encrypt(plaintext, key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });

    // 转换为十六进制字符串（bin2hex 类似操作）
    let encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);

    tgmudid = encryptedHex;
  }

  return tgmudid;
};

export { asecAgentData };
